function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { UnlockFilled } from "@ant-design/icons";
import { Button, Input, List, Drawer, Avatar, Space, Image, Card } from "antd";
import UserLogin from "./forms/UserLogin";
import { PersonLinesFill, HouseFill, FilePostFill, QuestionCircleFill, Activity, Globe2, SaveFill, Twitter, Facebook, Whatsapp } from 'react-bootstrap-icons';
import Start from "./forms/Start";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;
var Search = Input.Search;

var HomeContent = function HomeContent() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      drawerVisible = _useState2[0],
      setDrawerVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      connectVisible = _useState4[0],
      setConnectVisible = _useState4[1];

  var inputRef = useRef(null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "home-page-heroe",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: {
              span: 5
            },
            md: {
              span: 5
            },
            sm: 12,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                borderRadius: "8px",
                backgroundColor: "#FAFAFA",
                backgroundImage: "url(drawables/cl-heroe.jpg)",
                backgroundSize: "270px auto",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right",
                boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px"
              },
              children: /*#__PURE__*/_jsx(UserLogin, {
                ref: inputRef,
                id: "log"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 7
            },
            md: {
              span: 7
            },
            sm: 12,
            children: /*#__PURE__*/_jsxs("div", {
              className: "home-page-heroe-title",
              children: [/*#__PURE__*/_jsx("b", {
                style: {
                  color: "#A04707"
                },
                children: "CLINIQUEADMIN"
              }), /*#__PURE__*/_jsx("h1", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Gerez votre structure de sant\xE9 dans le CLOUD avec un logiciel intuitif et s\xE9curis\xE9"
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setDrawerVisible(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "Commencer"
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("b", {
                children: ["Vous avez d\xE9j\xE0 un compte ? ", /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    var _document$getElementB, _inputRef$current;

                    (_document$getElementB = document.getElementById("log")) === null || _document$getElementB === void 0 || _document$getElementB.scrollIntoView({
                      behavior: "smooth"
                    });
                    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Entrez vos identifiants pour acc\xE9der \xE0 votre compte"
                  })
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "default",
                  size: "large",
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Facebook, {
                      size: 30
                    })
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  size: "large",
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Whatsapp, {
                      size: 30
                    })
                  })
                })]
              })]
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m1.jpeg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Identification de vos patients"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m2.jpeg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gestion du laboratoire biochimique",
              x: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m3.jpeg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Comptes rendu de consultations"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m6.jpg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gestion des unit\xE9s d'imagerie"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m5.jpeg"
            }),
            actions: [],
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gestion de service d'ophtalmologie"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m4.jpeg"
            }),
            actions: [],
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gerer vos factures, clients, patients"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Commencer ... !"
      }),
      width: "100%",
      onClose: function onClose() {
        setDrawerVisible(false);
      },
      destroyOnClose: false,
      open: drawerVisible,
      children: /*#__PURE__*/_jsx(Start, {})
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["Se connecter \xE0 ", /*#__PURE__*/_jsx(UnlockFilled, {}), " CliniqueAdmin"]
      }),
      headerStyle: {
        background: "#F2F1E7"
      },
      height: "350px",
      onClose: function onClose() {
        setConnectVisible(false);
      },
      destroyOnClose: false,
      placement: "top",
      open: connectVisible,
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 5,
          sm: 8,
          children: /*#__PURE__*/_jsx(UserLogin, {})
        }), /*#__PURE__*/_jsx(Col, {})]
      })
    })]
  });
};

export default HomeContent;